<div>
  <h2>Optimize your website on your<br/> own hosting with 10Web Booster</h2>
  <p>Follow these steps to get started:</p>
  <div class="db-booster-plugin-download-dialog__steps-wrap mt24 mb30">
    <div class="db-booster-plugin-download-dialog__step" *ngFor="let step of boosterSteps; let i = index">
      <div class="db-booster-plugin-download-dialog__checkmark">
        <div>
          <div>
            <i class="db-icon db-icon-ds-checkmark"></i>
          </div>
        </div>
      </div>
      <span>Step {{i + 1}}</span>
      <h3 class="mb2" [innerHTML]="step.title"></h3>
      <p [innerHTML]="step.desc"></p>
    </div>
  </div>
  <div class="text-center">
    <button (click)="downloadBoosterPlugin()" class="ds-btn-green ds-btn-l">
      <span *ngIf="!loading">Download & Connect</span>
      <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
    </button>
  </div>
  <div class="db-available-plugin">{{'text_downloadBoosterPluginDesc' | dbText}}</div>
</div>
<div class="divider-optimize" *ngIf="!isMobile"></div>
<div class="db-booster-plugin-download-dialog__info-content" *ngIf="!isMobile">
  <div @scale class="intro-img"></div>
  <div class="optimize-checklist">
    <span>Access the benefits of 10Web Booster</span>
    <div class="db-checklist-content">
    <div class="db-checklist-item" *ngFor="let point of boosterService">
      <i class="db-icon db-icon-ds-checkmark-bg mr8"></i><p [innerHTML]="point"></p>
    </div>
    </div>
  </div>
</div>
